import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { formatDateTime } from 'util/masks'
import { paymentMethods } from '../Order'
import { ApplicationState } from 'AppReducer'

import Pagination from 'util/modules/Pagination'
import PartnerStars from 'panel/partner/config/components/PartnerStars'

const OrderList: React.FC = () => {
  const { orders: { items, pagination } } = useSelector((state: ApplicationState) => state.orderReducer)

  const gridTemplateColumns = '60px 60px 1fr 200px 200px 150px 200px 48px'

  return (
    <div className="row margin-top-32">
      <div className="list">
        <div className="list-header" style={{ display: 'grid', gridTemplateColumns }}>
          <div>Cod</div>
          <div style={{ gridColumn: '2/4' }}>Parceiro</div>
          <div>Pagamento</div>
          <div>Status</div>
          <div>Avaliação</div>
          <div>Data do Pedido</div>
          <div />
        </div>
        {
          items.length === 0 &&
          <div className="list-row grid-span">
            Nenhuma ordem de compra à exibir
          </div>
        }
        {
          items.map((order, i) => {
            return (
              <div key={i} className="list-row" style={{ display: 'grid', gridTemplateColumns }}>
                <div>{ order.id }</div>
                <img
                  style={{ width: 50, borderRadius: 5 }}
                  src={order.partner?.pictureTiny} alt="Parceiro"
                />
                <div>{ order.partner?.name }</div>
                <div>{ paymentMethods[order.paymentMethod] }</div>
                <div style={{ color: order.status?.color }}>{order.status?.alias }</div>
                <div><PartnerStars average={order.reviewStars || 0} /></div>
                <div>{ formatDateTime(order.createdAt) }</div>
                <NavLink to={`/panel/order/${order.partner.id}/${order.id}`} className="button primary">
                  <i className="far fa-1x fa-folder-open"></i>
                </NavLink>
              </div>
            )
          })
        }

      </div>

      <Pagination pagination={pagination} />
    </div>
  )
}

export default OrderList
